export default "__VITE_PUBLIC_ASSET__9bfa24c9__"